<template>
    <div class="studio-swipper-container" :class="{ 'global-limited-1360px-container': matchMobile }">
        <div class="studio-swipper-title">
            <CommonComponentsProductsTitleTopicTitle :topic-title="topicTitle" :color-index="colorIndex" />
        </div>
        <CommonComponentsProductsDownload v-if="!isCN" product="studio" class="swipper-download" />
        <div class="studio-swipper-clothing">
            <!-- <img :src="image.bg" alt="" class="studio-bg" /> -->
            <div class="studio-bg">
                <CommonComponentsSVGProductStudioBg />
            </div>
            <img :src="bg" alt="" class="studio-boy" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import i18n from '@/locales';
    import bg from '@assets/imgs/Products/Studio/Swipper/bg.png';
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    const { t } = i18n.global;
    const isCN = ifCNLocale();
    gsap.registerPlugin(ScrollTrigger);
    const colorIndex = 2;
    const topicTitle: FunctionTitle = {
        title: 'global_swipper_title',
        colorTitle: 'global_studio_swipper_colorTitle_2',
        subTitle: 'global_home_header_submenu_link_0_0_des',
    };
    const fixBreakLine = () => {
        // 断句问题
        if (matchMobile()) {
            (document.querySelector('.topic-subtitle') as HTMLElement).innerHTML = t(
                'global_home_header_submenu_link_0_0_des',
            );
        }
    };
    onMounted(() => {
        gsap.timeline({
            scrollTrigger: {
                // markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
                trigger: '.studio-swipper-clothing',
                scrub: true,
                start: '40% center',
                end: '70% top',
            },
        }).to(' .studio-boy', {
            scale: 0.8,
            y: 100,
        });

        fixBreakLine();
    });
</script>

<style lang="less" scoped>
    .studio-swipper-container {
        // position: relative;
        @media (max-width: @screen-mobile-width) {
            width: 100vw;
            height: 100vh;
        }
        .studio-swipper {
            &-title {
                padding-top: .convert(106px) [ @vw];
                width: 100%;
            }

            &-clothing {
                position: relative;
                height: .convert(950px) [ @vw];
                padding-top: .convert(60px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    height: 45vh;
                }
                .studio-bg {
                    position: absolute;
                    width: 100%;
                    height: auto;
                    top: 0%;
                    // @media (min-width: 1441px) {
                    //     bottom: -15%; //适配版
                    // }
                    @media (max-width: @screen-mobile-width) {
                        // width: 100%;
                        top: 50%;
                    }
                    :deep(.svg-studio) {
                        width: 100%;
                        height: auto;
                    }
                }
                .studio-boy {
                    height: .convert(949px) [ @vw];
                    width: .convert(535px) [ @vw];
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 0;
                    @media (max-width: @screen-mobile-width) {
                        width: .convert(227px) [ @vw-mobile];
                        height: .convert(398px) [ @vw-mobile];
                        top: 15%;
                    }
                }
            }
        }

        .swipper-download {
            margin-top: .convert(20px) [ @vw];
            margin-bottom: .convert(5px) [ @vw];

            @media (max-width: @screen-mobile-width) {
                margin-top: .convert(10px) [ @vw-mobile];
                margin-bottom: 0px;
            }
        }
    }
</style>
